import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/")({
  beforeLoad: () => {
    return redirect({ to: "/admin/users", replace: true, statusCode: 307 });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return null;
}
